import React from "react";
import "../../App.css";
import i18next from "../../i18n";
import { Helmet } from "react-helmet-async";
import article_img_2 from "../../images/articles/laptop-2548147_1920.jpg";

function Tilgjengelighetsdirektivet() {
  return (
    <div className="min-h-screen bg-white">
      <Helmet>
        <title>{i18next.t("pages.articles.list.pdf.title")}</title>
        <meta
          name="description"
          content={i18next.t("pages.articles.list.pdf.description")}
        />
        <link
          rel="canonical"
          href="https://xperconsulting.no/artikler/gjor-dokumentene-dine-tilgjengelige"
        />
      </Helmet>
      <div className="container max-w-xl pt-36 justify-start items-center text-main-dark flex flex-col md:flex-row pb-24 md:gap-16">
        <div className="w-full md:w-3/5 text-left  ">
          <h1 className="text-5xl font-bold text-main-dark mb-2">
            {i18next.t("pages.articles.list.pdf.title")}
          </h1>
          <p className="text-lg text-secondary">
            {i18next.t("pages.articles.list.pdf.date")}
          </p>
        </div>
        <div className="w-full md:w-2/5 text-left  ">
          <img
            className="w-full h-full object-cover"
            src={article_img_2}
            alt={i18next.t("pages.articles.list.pdf.imageAlt")}
          />
        </div>
      </div>
      <div className="bg-gray">
        <div className="container max-w-xl text-xl text-left py-24 text-main-dark">
          <div className=" max-w-sm">
            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.pdf.sections.intro.title")}
            </h2>
            <p>
              {i18next.t("pages.articles.list.pdf.sections.intro.content1")}
            </p>
            <p>
              {i18next.t("pages.articles.list.pdf.sections.intro.content2")}
            </p>
            <h2 className="text-3xl font-bold mt-16 mb-2">
              {i18next.t("pages.articles.list.pdf.sections.problem.title")}
            </h2>
            <p>
              {i18next.t("pages.articles.list.pdf.sections.problem.content")}
            </p>
            <h2 className="text-3xl font-bold mt-16 mb-2">
              {i18next.t("pages.articles.list.pdf.sections.solution.title")}
            </h2>
            <p>
              {i18next.t("pages.articles.list.pdf.sections.solution.content")}
            </p>
            <p className="mb-4">
              {i18next.t(
                "pages.articles.list.pdf.sections.solution.withDocEngine"
              )}
            </p>
            <ul className="list-disc list-outside ml-8 mb-12 ">
              <li>
                {i18next.t(
                  "pages.articles.list.pdf.sections.solution.features.1"
                )}
              </li>
              <li>
                {i18next.t(
                  "pages.articles.list.pdf.sections.solution.features.2"
                )}
              </li>
              <li>
                {i18next.t(
                  "pages.articles.list.pdf.sections.solution.features.3"
                )}
              </li>
            </ul>
            <a
              className="font-bold underline hover:text-contrast-ink"
              href="https://xperconsulting.no/docengine "
            >
              {i18next.t("pages.articles.list.pdf.sections.solution.link")}
            </a>
            <h2 className="text-3xl font-bold mt-16 mb-2">
              {i18next.t("pages.articles.list.pdf.sections.pdfua.title")}
            </h2>
            <p>{i18next.t("pages.articles.list.pdf.sections.pdfua.content")}</p>
            <p className="mb-4">
              {i18next.t("pages.articles.list.pdf.sections.pdfua.means")}
            </p>
            <ul className="list-disc list-outside  ml-8 mb-12 ">
              <li>
                {i18next.t("pages.articles.list.pdf.sections.pdfua.features.1")}
              </li>
              <li>
                {i18next.t("pages.articles.list.pdf.sections.pdfua.features.2")}
              </li>
              <li>
                {i18next.t("pages.articles.list.pdf.sections.pdfua.features.3")}
              </li>
            </ul>
            {i18next.t("pages.articles.list.pdf.sections.pdfua.note")}
            <p className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.pdf.sections.projects.title")}
            </p>
            <p className="mb-6">
              {i18next.t("pages.articles.list.pdf.sections.projects.content")}
            </p>
            <ul className="list-disc list-outside  ml-8 mb-12 ">
              <li>
                {i18next.t(
                  "pages.articles.list.pdf.sections.projects.features.1"
                )}
              </li>
              <li>
                {i18next.t(
                  "pages.articles.list.pdf.sections.projects.features.2"
                )}
              </li>
              <li>
                {i18next.t(
                  "pages.articles.list.pdf.sections.projects.features.3"
                )}
              </li>
            </ul>
            <p>{i18next.t("pages.articles.list.pdf.sections.projects.help")}</p>
            <h2 className="text-3xl font-bold mt-16 mb-2">
              {i18next.t("pages.articles.list.pdf.sections.oldDocs.title")}
            </h2>
            <p>
              {i18next.t("pages.articles.list.pdf.sections.oldDocs.content")}
            </p>
            <p className="text-3xl font-bold mt-12 mb-4">
              {i18next.t("pages.articles.list.pdf.sections.benefits.title")}
            </p>
            <ul className="list-disc list-outside  ml-8 mb-16 ">
              <li>
                {i18next.t(
                  "pages.articles.list.pdf.sections.benefits.features.1"
                )}
              </li>
              <li>
                {i18next.t(
                  "pages.articles.list.pdf.sections.benefits.features.2"
                )}
              </li>
              <li>
                {i18next.t(
                  "pages.articles.list.pdf.sections.benefits.features.3"
                )}
              </li>
              <li>
                {i18next.t(
                  "pages.articles.list.pdf.sections.benefits.features.4"
                )}
              </li>
            </ul>
            <p className="text-xl font-bold mt-12 mb-2 text-center">
              {i18next.t("pages.articles.list.pdf.sections.cta.question")}
            </p>
            <p className="text-center">
              <a
                className="font-bold underline hover:text-contrast-ink"
                href="/skjema/kontakt-oss"
              >
                {i18next.t("pages.articles.list.pdf.sections.cta.button")}
              </a>{" "}
              {i18next.t("pages.articles.list.pdf.sections.cta.follow")}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Tilgjengelighetsdirektivet;
